import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import LoadingScreen from '../../components/LoadingScreen';

const EarningsAnalyticsComponent = React.lazy(() => import('./components/EarningsAnalytics'));

const EarningsAnalytics = () => {
  const { pathname } = useLocation();
  return (
    <div>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <EarningsAnalyticsComponent />
      </Suspense>
    </div>
  );
};

export default EarningsAnalytics;
